_ = require 'underscore'

module.exports = (getKey, colls...) ->
  collection = {}
  _.flatten(colls).forEach (x) ->
    collection[getKey x] = x
  return (value for own key, value of collection)



// WEBPACK FOOTER //
// ./app/scripts/lib/util/value-union.coffee